import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "game-generator screen" }
const _hoisted_2 = { class: "menu-content" }
const _hoisted_3 = { class: "generator-body" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Jugadores", -1)
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { type: "submit" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Agregar jugador ")
const _hoisted_8 = { class: "option-row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "autocollect" }, "Recolectar recursos automáticamente", -1)
const _hoisted_10 = { class: "game-id" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" ID de partida: ")
const _hoisted_12 = { class: "form-actions" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Cancelar ")
const _hoisted_14 = ["disabled"]
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Comenzar partida ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_screen_title = _resolveComponent("screen-title")!
  const _component_player_picture = _resolveComponent("player-picture")!
  const _component_X = _resolveComponent("X")!
  const _component_UserPlus = _resolveComponent("UserPlus")!
  const _component_ArrowLeft = _resolveComponent("ArrowLeft")!
  const _component_Play = _resolveComponent("Play")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_screen_title),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.players.length > 0)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.players, (player) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["player", [
              `player-${player.id}`,
              { 'player-active': player.id === _ctx.activePlayerId },
            ]]),
                key: player.id
              }, [
                _createVNode(_component_player_picture, { player: player }, null, 8, ["player"]),
                _createTextVNode(" " + _toDisplayString(player.name) + " ", 1),
                _createElementVNode("button", {
                  class: "btn-remove-player",
                  onClick: ($event: any) => (_ctx.removePlayer(player.id)),
                  title: "Quitar jugador"
                }, [
                  _createVNode(_component_X, {
                    size: 14,
                    "stroke-width": 2
                  })
                ], 8, _hoisted_5)
              ], 2))
            }), 128))
          : _createCommentVNode("", true),
        (_ctx.players.length < 4 && _ctx.activePlayerId === null)
          ? (_openBlock(), _createElementBlock("form", {
              key: 1,
              onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.createPlayer()), ["prevent"]))
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.creatingPlayerName) = $event)),
                autofocus: ""
              }, null, 512), [
                [_vModelText, _ctx.creatingPlayerName]
              ]),
              _createElementVNode("button", _hoisted_6, [
                _createVNode(_component_UserPlus, {
                  size: 16,
                  "stroke-width": 1.5
                }, null, 8, ["stroke-width"]),
                _hoisted_7
              ])
            ], 32))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            id: "autocollect",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.autoCollect) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.autoCollect]
          ]),
          _hoisted_9
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("code", null, _toDisplayString(_ctx.gameId), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            class: "btn-ghost",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goBack()))
          }, [
            _createVNode(_component_ArrowLeft, {
              size: 16,
              "stroke-width": 1.5
            }, null, 8, ["stroke-width"]),
            _hoisted_13
          ]),
          _createElementVNode("button", {
            disabled: _ctx.players.length < 3,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.startGame()))
          }, [
            _createVNode(_component_Play, {
              size: 16,
              "stroke-width": 1.5
            }, null, 8, ["stroke-width"]),
            _hoisted_15
          ], 8, _hoisted_14)
        ])
      ])
    ])
  ]))
}